// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tasks_tabContainer__Es32-","addressBox":"tasks_addressBox__1rV_l","needToKnowMain":"tasks_needToKnowMain__1z6i5"};